import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
  constructor() {}

  convert(data: object, obj?: any[]) {
    const dat = data;
    const formdata = new FormData();
    // eslint-disable-next-line guard-for-in
    for (const i in data) {
      obj.forEach(el => {
        formdata.append(i, data[i]);
      });
    }
    return formdata;
  }

  convertToFormdata(data, files?: any[]) {
    const formData = new FormData();
    const fullData = data;
    if (files && files[0]) {
      files.forEach(key => {
        const keyBU = key;
        key = key.replace(/~/, '');
        const dats = fullData[key];
        // console.log(key, keyBU);
        key = keyBU === key ? key : key + '[]';
        console.log(key);
        if (dats && typeof dats === 'object') {
          // eslint-disable-next-line guard-for-in
          for (const fil of dats) {
            formData.append(key, fil, fil.name);
          }
          delete fullData[key];
        }
      });
    }

    // eslint-disable-next-line guard-for-in
    for (const key in fullData) {
      // console.log(fullData[key]);
      formData.append(key, fullData[key]);
    }
    return formData;
  }
}
